import get from 'lodash.get';
import React from 'react';
import * as Components from '../components';
const getProps = (self, props, type) => {
  const obj = {};
  const keys = Object.keys(props);
  if (keys && keys.length) {
    keys.forEach((e: any) => {
      obj[e] = Array.isArray(props[e].value)
        ? get(self[type], props[e].value[0], props[e].value[1])
        : self[type][props[e].value];
    });
  }
  return obj;
};

const getFunctionProps = (self, fnProps) => {
  const props = {};
  const keys = Object.keys(fnProps);
  if (keys && keys.length) {
    keys.forEach(e => {
      const element = fnProps[e];
      if (element.parameters) {
        const from = element.parameters[element.parameters.length - 1];
        const allParameters = element.parameters.slice(
          0,
          element.parameters.length - 1
        );
        const allParmsArr = [];
        allParameters.forEach(ele => {
          allParmsArr.push(get(self[from], ele, element.defaultValue));
        });
        props[e] = self[element.value](...allParmsArr);
      } else {
        if (self[element.value]) {
          props[element.value] = self[element.value].bind(self);
        }
      }
    });
  }
  return props;
};

const getConstantProps = constantProps => {
  const props = {};
  const keys = Object.keys(constantProps);

  if (keys && keys.length) {
    keys.forEach(e => {
      const element = constantProps[e];
      props[e] = element.isComponent
        ? Components[element.value]
        : element.value;
    });
  }
  return props;
};

const recursiveCmpTree = (self, ele) => {
  let Component: any;
  if (Components[ele.component]) {
    Component = Components[ele.component];
  } else {
    throw Error(`No component found of name ${ele.component}`);
  }

  let shouldRender = true;
  if (ele.conditionalRender && ele.conditionalRender.length) {
    const from = ele.conditionalRender[ele.conditionalRender.length - 1];
    shouldRender = get(self[from], ele.conditionalRender[0]);
    if (Array.isArray(shouldRender) && !shouldRender.length) {
      shouldRender = false;
    }
  }

  if (ele.childComponent) {
    return (
      shouldRender && (
        <Component
          {...getProps(
            self,
            ele && ele.stateProps ? ele.stateProps : {},
            'state'
          )}
          {...getProps(self, ele && ele.props ? ele.props : {}, 'props')}
          {...getFunctionProps(self, ele && ele.fnProps ? ele.fnProps : {})}
          {...getConstantProps(
            ele && ele.constantProps ? ele.constantProps : {}
          )}
          key={ele.key}
        >
          {ele.childComponent.map(e => {
            return recursiveCmpTree(self, e);
          })}
        </Component>
      )
    );
  } else {
    return (
      shouldRender && (
        <Component
          {...getProps(
            self,
            ele && ele.stateProps ? ele.stateProps : {},
            'state'
          )}
          {...getProps(self, ele && ele.props ? ele.props : {}, 'props')}
          {...getFunctionProps(self, ele && ele.fnProps ? ele.fnProps : {})}
          {...getConstantProps(
            ele && ele.constantProps ? ele.constantProps : {}
          )}
          key={ele.key}
        />
      )
    );
  }
};

export function getComponentTree(COMPONENT_MAP: any) {
  return COMPONENT_MAP.map(ele => {
    return recursiveCmpTree(this, ele);
  });
}



// WEBPACK FOOTER //
// ./utils/componentTree.tsx